import React, { useEffect, useState } from "react";
import SummaryClasses from "./Referral.module.css";
import { useStore } from "Store";
import { Referral_My } from "Services/Requests";
import { showErrorNotification } from "Utils/Notifications";

type ReferralItem = {
    referral_info_id: number;
    friend_name: string;
    friend_email: string;
    friend_phone_number: string;
    state: string;
    referral_date: string;
    is_converted: number;
    referral_tax_detail_id: any;
    file_number: any;
    name: any;
    phone_number: any;
    paid_status: any;
    amount: any;
    tax_filed_date: any;
};

function TaxSummary() {
    const setShow = useStore((s: any) => s.setShowReferModal);
    const [list, setList] = useState<ReferralItem[]>([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        let mounted = true;
        const load = async () => {
            setLoading(true);
            try {
                const res = await Referral_My();
                // Axios: data is in res.data
                const items = res?.data?.data || [];
                if (mounted) setList(items);
            } catch (err: any) {
                const message =
                    err?.response?.data?.Message ||
                    err?.message ||
                    "Failed to load referrals";
                showErrorNotification(message);
            } finally {
                if (mounted) setLoading(false);
            }
        };
        load();
        return () => {
            mounted = false;
        };
    }, []);

    return (
        <div className={SummaryClasses["Container"]}>
            <div className={SummaryClasses["info"]}>
                <div
                    style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                    }}>
                    <h3>Referral</h3>
                    <button
                        className={SummaryClasses["referPageButton"]}
                        onClick={() => setShow(true)}>
                        Refer a Friend
                    </button>
                </div>

                <table>
                    <thead>
                        <tr>
                            <th>S.NO</th>
                            <th>Friend Name</th>
                            <th>Friend Email</th>
                            <th>Phone</th>
                            <th>State</th>
                            <th>Referral Date</th>
                            <th>Paid Status</th>
                            <th>Amount</th>
                        </tr>
                    </thead>
                    <tbody>
                        {loading ? (
                            <tr>
                                <td colSpan={8}>Loading...</td>
                            </tr>
                        ) : list.length === 0 ? (
                            <tr>
                                <td colSpan={8}>No referrals found</td>
                            </tr>
                        ) : (
                            list.map((row, idx) => (
                                <tr key={row.referral_info_id}>
                                    <td>{idx + 1}</td>
                                    <td>{row.friend_name}</td>
                                    <td>{row.friend_email}</td>
                                    <td>{row.friend_phone_number}</td>
                                    <td>{row.state}</td>
                                    <td>
                                        {row.referral_date
                                            ? new Date(
                                                  row.referral_date
                                              ).toLocaleString()
                                            : "-"}
                                    </td>
                                    <td>
                                        {row.paid_status == 0 ? (
                                            <span
                                                className={
                                                    SummaryClasses["notPaid"]
                                                }>
                                                Not Paid
                                            </span>
                                        ) : (
                                            <span
                                                className={
                                                    SummaryClasses["paid"]
                                                }>
                                                {"Paid"}
                                            </span>
                                        )}
                                    </td>
                                    <td>
                                        {row.amount != null ? row.amount : "-"}
                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
}

export default TaxSummary;
